import { useTheme } from "@shared/primitive-components"

type LogoVariants = "black"

interface LogoProps extends React.SVGAttributes<SVGElement> {
  variant?: LogoVariants
}

export const LogoIcon = ({ variant, ...rest }: LogoProps) => {
  const theme = useTheme()
  switch (variant) {
    case `black`:
    default:
      return <IconSVG fill={theme.palette.coal.dark} {...rest} />
  }
}

interface Props {
  fill: string
}

const IconSVG = ({ fill, ...props }: React.SVGAttributes<SVGElement> & Props) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 350.5 281.8"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <g>
        <path
          fill={fill}
          d="M248.6,0h-62.2L280,128.7c5,6.9,5,16.3,0,23.2l-62.8,86.4h-31.1l62.8-86.4c5-6.9,5-16.3,0-23.2L155.4,0H0
			l101.9,140.2L0,280.5h62.2l93.5-128.6c5-6.9,5-16.3,0-23.2L92.8,42.2h31.1l62.8,86.4c5,6.9,5,16.3,0,23.2L93.2,280.5h155.4
			l101.9-140.2L248.6,0z"
        />
      </g>
    </g>
  </svg>
)

LogoIcon.defaultProps = {
  variant: `black`,
}
